<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-xs-12 col-sm-12 text--base">
        <div class="chart__viz-roadmap container-fluid chart__white">
          <div class="row">
            <div class="col-xs-12 col-12 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 offset-md-2 offset-sm-1">
              <VizStageEnablers />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VizStageEnablers from '@/components/content/VizStageEnablers.vue';

export default {
  name: 'App2RoadmapDiamond',
  components: {
    VizStageEnablers,
  },
};
</script>


<style scoped lang="scss">
.chart__viz-roadmap {
  padding: 60px 0;
  @media #{map-get($media-breakpoints, 'mobile')} {
    padding: 30px 0;
  }
}
</style>